// extracted by mini-css-extract-plugin
module.exports = {"base":"PageHeaderTitle-module-base","isInverted":"PageHeaderTitle-module-is-inverted"};